import { render, staticRenderFns } from "./OrganizationsDialog.vue?vue&type=template&id=6ffdcc34&scoped=true"
import script from "./OrganizationsDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationsDialog.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsDialog.vue?vue&type=style&index=0&id=6ffdcc34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffdcc34",
  null
  
)

export default component.exports